module.exports = __webpack_public_path__ + "img/integratedMarketing_2.5a473ffb.png";